import React from 'react'
import './App.css'
import RouteList from './navigation/RouteList'

function App() {
  return <RouteList />
}

export default App
